import store from "redux/Store";
import { _expectPermission } from "./ModuleUtils";

export const _PermittedContent = (modulePath, expects) => {

  const state = store.getState();
  let user = state?.user;

  if (user?.credentials) {
    const { credentials: { sysPermit, orgPermit, orgID } } = user;
    return _expectPermission(sysPermit, orgPermit, orgID, modulePath, expects);
  }

  return false;
}
